import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { StepWizardChildProps } from './StepWizard';

const useStyles = makeStyles({
  step: {
    opacity: 0,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 0,
    display: 'none',
  },
  active: {
    display: 'block',
    opacity: 1,
    pointerEvents: 'inherit',
    position: 'relative',
    zIndex: 1,
  },
});

const Step = ({
  children,
  isActive = false,
  transitions = {},
}: StepWizardChildProps) => {
  const classes = useStyles({});

  return (
    <div
      className={clsx(classes.step, transitions, isActive && classes.active)}
    >
      {children}
    </div>
  );
};

export default Step;
